import React, {
  forwardRef,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { Description } from "../schema";
import {
  Accordion,
  Button,
  Checkbox,
  Icon,
  List,
  Modal,
  Toast,
  WhiteSpace,
} from "antd-mobile";
import Grid from "../Grid";

interface PageProps {
  description: {
    type: string;
    name?: string;
    fields: Description[];
    title: string;
  };
  mobileTitle?: { [name: string]: string };
  data?: { [key: string]: any };
  hidden?: { [key: string]: any };
  onChange: (
    value: { [key: string]: any },
    hidden?: {
      //用户删除的字段
      [key: string]: boolean;
    },
    detailIndex?: number
  ) => void;
}

export default forwardRef(
  (
    { description, mobileTitle, data, hidden, onChange }: PageProps,
    ref: any
  ) => {
    const [dataHiddenStatus, setDataHiddenStatus] = useState<{
      [key: string]: boolean;
    }>();
    const [visible, setVisible] = useState<boolean>(false);
    const [checkedOptions, setCheckedOptions] = useState<{ name: string }[]>(
      []
    );
    const [defaultData, setDefaultData] = useState<{ [key: string]: any }>(
      data ? data : {}
    );
    const [pageData, setPageData] = useState<{
      type: string;
      name?: string;
      fields: Description[];
      title: string;
    }>();

    useMemo(() => {
      setPageData(description);
    }, [description]);

    const gridRef = useRef<any>(null);
    useImperativeHandle(ref, () => ({
      jumpPage: () => {
        if (pageData?.type === "detail") return true;
        return gridRef.current?.validate();
      },
      dataHiddenStatus: () => {
        return gridRef.current?.dataHiddenStatus();
      },
      hidden: (fieldHidden: any) => {
        return gridRef.current?.hidden(fieldHidden);
      },
      // show: (fieldShow: any) => {
      //   return gridRef.current?.show(fieldShow);
      // },
    }));

    return (
      <>
        {pageData && (
          <>
            <List>
              <List.Item
                style={{ fontWeight: "bold" }}
                extra={
                  pageData.type === "fields" && (
                    <Icon
                      size={"xs"}
                      style={{ touchAction: "none" }}
                      key={`deleteName`}
                      type={"plus"}
                      onClick={() => {
                        if (gridRef.current?.dataHiddenStatus() === undefined) {
                          Toast.info("无删除内容", 1);
                        } else {
                          setDataHiddenStatus(
                            gridRef.current?.dataHiddenStatus()
                          );
                          setCheckedOptions([]);
                          setVisible(true);
                        }
                      }}
                    />
                  )
                }
              >
                {pageData?.title}
              </List.Item>
              {description && description.type === "detail" ? (
                <>
                  {
                    <>
                      {defaultData &&
                        description.name &&
                        defaultData[description.name] !== undefined &&
                        defaultData[description.name].map(
                          (rowData: any, detailIndex: number) => (
                            <>
                              <Accordion>
                                <Accordion.Panel
                                  header={
                                    <div
                                      style={{
                                        width: "100%",
                                        display: "inline-flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      明细 {detailIndex + 1}
                                      <button
                                        type="button"
                                        style={{
                                          marginRight: "30px",
                                          border: "none",
                                          backgroundColor: "transparent",
                                          color: "#108ee9",
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          Modal.alert("提示", "是否确认删除", [
                                            {
                                              text: "取消",
                                              onPress: () => {},
                                            },
                                            {
                                              text: "确定",
                                              onPress: () => {
                                                setDefaultData((prevState) => {
                                                  if (!description.name) return;
                                                  const cloned = {
                                                    ...prevState,
                                                  };
                                                  if (
                                                    cloned[description.name]
                                                      .length === 1
                                                  )
                                                    delete cloned[
                                                      description.name
                                                    ];
                                                  else
                                                    cloned[
                                                      description.name
                                                    ].splice(detailIndex, 1);
                                                  return cloned;
                                                });
                                              },
                                            },
                                          ]);
                                        }}
                                      >
                                        删除
                                      </button>
                                    </div>
                                  }
                                >
                                  <Grid
                                    ref={gridRef}
                                    data={
                                      defaultData[description.name!][
                                        detailIndex
                                      ]
                                    }
                                    descriptions={description.fields}
                                    type={description.type}
                                    onChange={(temp, temp2) => {
                                      onChange(temp, temp2, detailIndex);
                                    }}
                                  />
                                </Accordion.Panel>
                              </Accordion>
                            </>
                          )
                        )}
                      <WhiteSpace size={"lg"} />
                      <div
                        style={{
                          width: "100%",
                          display: "inline-flex",
                          justifyContent: "center",
                        }}
                      >
                        <Button
                          inline
                          size="small"
                          style={{
                            color: "#5B8FF9",
                            border: "none",
                            borderColor: "white",
                          }}
                          onClick={() => {
                            //设置明细每一行的默认数据
                            let rowData: { [x: string]: any } = {};
                            const fields = description.fields;
                            fields.forEach((rowDescription, index) => {
                              rowData[rowDescription.fieldName] = undefined;
                            });
                            setDefaultData((prevState) => {
                              //将默认数据放置到页面渲染的变量中
                              const cloned = { ...prevState };
                              let list = cloned[description.name!];
                              if (list === undefined) {
                                list = [rowData];
                              } else {
                                list.push(rowData);
                              }
                              cloned[description.name!] = list;
                              return cloned;
                            });
                          }}
                        >
                          + 增加明细
                        </Button>
                      </div>
                      <WhiteSpace size={"lg"} />
                    </>
                  }
                </>
              ) : (
                <Grid
                  ref={gridRef}
                  descriptions={description.fields}
                  mobileTitle={mobileTitle}
                  type={description.type}
                  data={data}
                  hidden={hidden}
                  onChange={onChange}
                />
              )}
            </List>
          </>
        )}

        {/* 删除内容的弹框 */}
        <Modal
          popup
          visible={visible}
          animationType="slide-up"
          onClose={() => {
            gridRef.current?.show(checkedOptions);
            setVisible(false);
          }}
        >
          <>
            <List renderHeader={"删除内容"}>
              {dataHiddenStatus &&
                Object.keys(dataHiddenStatus).map(
                  (name: string, index: number) => {
                    return (
                      <Checkbox.CheckboxItem
                        key={name}
                        checked={
                          checkedOptions.findIndex(
                            (item) => item.name === name
                          ) > -1
                        }
                        onChange={(e: any) => {
                          if (e.target.checked) {
                            setCheckedOptions([
                              ...checkedOptions,
                              { name: name },
                            ]);
                          } else {
                            setCheckedOptions((prevState) => {
                              const index = prevState.findIndex(
                                (item) => item.name === name
                              );
                              const cloned = [...prevState];
                              cloned.splice(index, 1);
                              return cloned;
                            });
                          }
                        }}
                      >
                        {mobileTitle && mobileTitle[name]}
                      </Checkbox.CheckboxItem>
                    );
                  }
                )}
            </List>
          </>
        </Modal>
      </>
    );
  }
);
